var React = require('react');

function Envelope (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.envelope{fill:#FFFFFF;}\n"),React.createElement("title",{"key":1}),React.createElement("g",{"id":"icomoon-ignore","key":2}),React.createElement("path",{"className":"envelope","d":"M29.6,25.4V11.7c-0.4,0.4-0.8,0.8-1.2,1.2c-2.6,2-5.1,4-7.6,6c-1.3,1.1-3,2.5-4.9,2.5h0c-1.9,0-3.5-1.4-4.9-2.5\n\tc-2.5-2.1-5.1-4.1-7.6-6c-0.4-0.4-0.9-0.8-1.2-1.2v13.7c0,0.3,0.3,0.6,0.6,0.6h26.3C29.4,25.9,29.6,25.7,29.6,25.4z M29.6,6.6\n\tc0-0.4,0.1-1.2-0.6-1.2H2.8c-0.3,0-0.6,0.3-0.6,0.6c0,2,1,3.8,2.6,5.1c2.4,1.9,4.8,3.8,7.2,5.7c0.9,0.8,2.7,2.4,3.9,2.4h0\n\tc1.2,0,3-1.6,3.9-2.4c2.4-1.9,4.8-3.8,7.2-5.7C28.2,10.1,29.6,8.1,29.6,6.6z M31.9,5.9v19.4c0,1.6-1.3,2.9-2.9,2.9H2.8\n\tc-1.6,0-2.9-1.3-2.9-2.9V5.9c0-1.6,1.3-2.9,2.9-2.9h26.3C30.6,3.1,31.9,4.4,31.9,5.9z","key":3})]);
}

Envelope.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 31.9 31.3","style":{"enableBackground":"new 0 0 31.9 31.3"},"xmlSpace":"preserve"};

module.exports = Envelope;

Envelope.default = Envelope;



//////////////////
// WEBPACK FOOTER
// ./src/img/svg/envelope.svg
// module id = 396
// module chunks = 114276838955818